export const SalesTax = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.625 9.48633C10.6262 9.0046 12 8.01005 12 6.86133C12 5.7126 10.6262 4.71806 8.625 4.23633C8.83088 5.02619 8.94674 5.91775 8.94674 6.86133C8.94674 7.80491 8.83088 8.69647 8.625 9.48633Z"
        fill="url(#paint0_linear_6302_7249)"
      />
      <path
        d="M3.375 9.48633C1.37379 9.0046 0 8.01005 0 6.86133C0 5.7126 1.37379 4.71806 3.375 4.23633C3.16912 5.02619 3.05326 5.91775 3.05326 6.86133C3.05326 7.80491 3.16912 8.69647 3.375 9.48633Z"
        fill="url(#paint1_linear_6302_7249)"
      />
      <path
        d="M3.375 9.48633C3.85673 11.4875 4.85128 12.8613 6 12.8613C7.14872 12.8613 8.14327 11.4875 8.625 9.48633C7.83514 9.69221 6.94358 9.80807 6 9.80807C5.05642 9.80807 4.16486 9.69221 3.375 9.48633Z"
        fill="url(#paint2_linear_6302_7249)"
      />
      <path
        d="M3.375 4.23633C3.85673 2.23512 4.85128 0.861328 6 0.861328C7.14872 0.861328 8.14327 2.23512 8.625 4.23633C7.83514 4.03045 6.94358 3.91458 6 3.91458C5.05642 3.91458 4.16486 4.03045 3.375 4.23633Z"
        fill="url(#paint3_linear_6302_7249)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6302_7249"
          x1="8.625"
          y1="6.86133"
          x2="12"
          y2="6.86133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6302_7249"
          x1="0"
          y1="6.86133"
          x2="3.375"
          y2="6.86133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6302_7249"
          x1="3.375"
          y1="11.1738"
          x2="8.625"
          y2="11.1738"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6302_7249"
          x1="3.375"
          y1="2.54883"
          x2="8.625"
          y2="2.54883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
